var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup322(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_322",
    "data-name": "Group 322",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.318,
    height: 14.613,
    viewBox: "0 0 15.318 14.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 15.318,
    height: 14.613,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M354.516,216.55c-.363,0-.726.006-1.089.01-.081,0-.117-.033-.117-.115q0-.373,0-.747c0-.083.035-.116.117-.115.363,0,.726.007,1.089.01Z",
    transform: "translate(-339.198 -206.973)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M42.158,0h5.994c.232,0,.233,0,.233.239q0,2.653,0,5.306c0,.216,0,.216-.21.216-.364,0-.727,0-1.091,0-.116,0-.16-.036-.156-.154.007-.224,0-.448,0-.673,0-.1-.03-.133-.129-.133q-1.061,0-2.122,0c-.091,0-.123.035-.122.124,0,.224,0,.449,0,.673,0,.124-.04.164-.163.163-.777,0-1.554,0-2.332,0H36.145c-.219,0-.22,0-.22-.222q0-2.66,0-5.321c0-.218,0-.218.223-.218h6.009",
    transform: "translate(-34.491 0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M42.082,156.605H36.09c-.22,0-.22,0-.22-.221,0-.2.006-.4,0-.6-.005-.127.045-.173.165-.159a.929.929,0,0,0,.1,0H48.063c.05,0,.1,0,.149,0,.082,0,.116.035.116.116q0,.374,0,.747c0,.084-.038.117-.118.113-.05,0-.1,0-.149,0H42.082",
    transform: "translate(-34.435 -149.409)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M43.817,197.6c.4,0,.8,0,1.2,0a.7.7,0,0,1,.717.719c0,.329,0,.658,0,.987a.7.7,0,0,1-.7.7q-1.226,0-2.452,0a.7.7,0,0,1-.694-.7q0-.508,0-1.016a.7.7,0,0,1,.693-.7c.414,0,.827,0,1.241,0",
    transform: "translate(-40.209 -189.704)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M247.412,200.009c-.4,0-.8,0-1.2,0a.7.7,0,0,1-.721-.715q0-.493,0-.987a.7.7,0,0,1,.711-.71q1.211,0,2.422,0a.7.7,0,0,1,.714.707q0,.5,0,1a.7.7,0,0,1-.7.7c-.409,0-.817,0-1.226,0",
    transform: "translate(-235.688 -189.704)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M38,268.481c-.658,0-1.315,0-1.973,0-.147,0-.191-.048-.184-.189.01-.2.009-.409,0-.613-.006-.133.033-.189.175-.181.2.011.4-.008.6.006.158.011.2-.049.189-.2-.011-.239,0-.478,0-.717,0-.118.028-.171.158-.168.4.011.336-.045.342.34,0,.2,0,.4,0,.6,0,.1.027.144.135.143.384,0,.767,0,1.151,0,.1,0,.133-.033.132-.13,0-.269,0-.538,0-.807,0-.1.033-.143.138-.141.435.008.354-.049.361.349,0,.2,0,.4,0,.6,0,.1.033.133.13.132.229,0,.458,0,.687,0,.1,0,.144.033.141.138,0,.224-.008.449,0,.672.005.132-.042.171-.171.17-.668-.005-1.335,0-2,0",
    transform: "translate(-34.413 -255.784)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M241.6,268.5c-.658,0-1.315,0-1.973,0-.138,0-.183-.043-.177-.179.009-.209.01-.419,0-.628-.007-.142.049-.18.182-.175.209.008.419,0,.628,0,.121,0,.155-.041.152-.156-.007-.259,0-.518,0-.777,0-.111.04-.148.148-.146.419.008.345-.047.351.345q.005.3,0,.6c0,.092.023.137.126.136q.583-.006,1.166,0c.1,0,.127-.045.125-.136,0-.264,0-.528,0-.792,0-.106.031-.153.144-.151.424.008.349-.046.355.341,0,.194.006.389,0,.583,0,.115.031.161.152.156.209-.008.419,0,.628,0,.133-.005.189.033.182.175-.01.209-.01.419,0,.628.006.136-.039.181-.177.179-.668-.006-1.335,0-2,0",
    transform: "translate(-229.884 -255.801)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M11.911,253.352c0-.577,0-1.155,0-1.732,0-.136.04-.183.178-.179.376.012.322-.041.323.329,0,1.11,0,2.22,0,3.33,0,.15-.041.2-.193.194-.354-.014-.306.037-.308-.314,0-.543,0-1.085,0-1.628",
    transform: "translate(-11.432 -241.398)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M155.628,253.352c0-.577,0-1.155,0-1.732,0-.137.042-.182.179-.178.372.011.321-.039.322.315q0,1.665,0,3.33c0,.2,0,.206-.206.2-.332,0-.291.035-.292-.3,0-.548,0-1.1,0-1.643",
    transform: "translate(-149.409 -241.399)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M216,253.346c0,.582,0,1.165,0,1.747,0,.134-.036.185-.176.18-.377-.012-.323.041-.324-.327,0-1.11,0-2.22,0-3.33,0-.148.037-.2.192-.2.355.014.308-.036.309.313,0,.538,0,1.075,0,1.613",
    transform: "translate(-206.894 -241.377)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M359.723,253.346c0,.582,0,1.165,0,1.747,0,.134-.036.185-.176.18-.378-.012-.323.041-.324-.327,0-1.11,0-2.22,0-3.33,0-.148.037-.2.192-.2.355.014.308-.036.309.313,0,.538,0,1.075,0,1.613",
    transform: "translate(-344.873 -241.377)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M.608,216.558c-.164,0-.328,0-.492,0-.082,0-.117-.034-.116-.115q0-.373,0-.746c0-.082.034-.116.116-.116q.492,0,.984,0c.082,0,.117.034.116.116q0,.373,0,.746c0,.082-.034.117-.116.116-.164,0-.328,0-.492,0",
    transform: "translate(0 -206.971)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M150.278,216.527c-.154,0-.308,0-.462,0-.1,0-.144-.031-.142-.137,0-.234,0-.467,0-.7,0-.1.031-.143.137-.142.313,0,.626,0,.94,0,.1,0,.144.031.142.137-.005.234-.006.467,0,.7,0,.115-.048.146-.152.142-.154-.005-.308,0-.462,0",
    transform: "translate(-143.695 -206.94)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M204.188,216.538c-.159,0-.318,0-.477,0-.1,0-.132-.037-.131-.132q.005-.358,0-.716c0-.1.037-.132.132-.131q.477,0,.955,0c.1,0,.132.037.131.132q-.005.358,0,.716c0,.1-.037.133-.132.131-.159,0-.318,0-.477,0",
    transform: "translate(-195.449 -206.951)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M264.194,132.2c-.2,0-.4,0-.6,0-.1,0-.133-.034-.132-.131.006-.444-.046-.362.341-.368.323,0,.646,0,.969,0,.109,0,.15.036.148.146-.008.421.046.346-.341.354-.129,0-.258,0-.388,0Z",
    transform: "translate(-252.942 -126.442)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M48.353,330.044c0,.194,0,.388,0,.582,0,.092-.028.137-.127.135-.451-.006-.365.05-.371-.352-.005-.313,0-.626,0-.939,0-.118.03-.17.158-.167.4.011.335-.045.342.339,0,.134,0,.268,0,.4",
    transform: "translate(-45.941 -316.15)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M120.214,330.044c0,.184-.005.368,0,.552,0,.119-.03.17-.158.167-.4-.011-.337.045-.342-.339,0-.318,0-.636,0-.954,0-.118.03-.17.158-.167.4.011.335-.045.342.339,0,.134,0,.268,0,.4",
    transform: "translate(-114.932 -316.15)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M251.956,330.044c0,.194,0,.388,0,.582,0,.092-.028.137-.127.135-.451-.006-.365.05-.371-.352-.005-.313,0-.626,0-.939,0-.118.03-.17.158-.167.4.011.335-.045.342.339,0,.134,0,.268,0,.4",
    transform: "translate(-241.412 -316.15)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M323.823,330.05c0,.2,0,.4,0,.6,0,.095-.034.134-.13.133-.447-.006-.362.05-.368-.355,0-.318,0-.636,0-.954,0-.108.035-.15.146-.148.421.008.346-.046.354.341,0,.129,0,.258,0,.388Z",
    transform: "translate(-310.409 -316.167)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup322);
export default __webpack_public_path__ + "static/media/Group322.a74b2cf03183cfe7390a1d3e32c72210.svg";
export { ForwardRef as ReactComponent };